var Store = function(options) {
    options = options || {};

    var global = window;

    this.host = options.host || global.location.protocol + "//" + global.location.hostname + (global.location.port ? ':' + global.location.port: '');

    this.Collections = [];

    this.authenticityToken = null;
    this.urlPrefix = null;
    this.authToken = null;
    this.filter = null;
    this.loader = null;
    this.requests = [];

    var that = this;

    this.addCollection = function(options) {
        var newCollection = new Collection();
        newCollection.path = options.path || "";
        return(newCollection);
    };

    this.processOptions = function(options){
        options = options || {};
        options.collection = this;

        if(options.method !== "GET" && that.authenticityToken){
            options.authenticityToken = that.authenticityToken;
        }

        if(options.preSave){
            options.preSave(options.data);
        }

        if (options.queryParams){
            options.queryParams = "?" + that.utils.convertObjectToQueryString(options.queryParams);
        }
        else {
            options.queryParams = "";
        }

        if (options.filter && that.filter){
            options.filter = that.filter();
        }

        if (options.url) {
            options.url = options.url + options.queryParams + (options.filter ? "&" + options.filter : "");
        }
        else {
            options.path = options.path || this.path;

            if(options.path.indexOf("/") !== 0){
                options.path = "/" + options.path;
            }

            if(options.path.indexOf("?") > 0){
                options.queryParams = options.queryParams.replace("?","&");
            }

            if (that.urlPrefix) {
                options.path = that.urlPrefix + options.path;
            }

            options.url = that.host + options.path + options.queryParams + (options.filter ? "&" + options.filter : "");
        }

        if(options.showLoader && that.loader){
            options.loader = that.loader;
        }

        if(that.onExpireSession){
            options.onExpireSession = that.onExpireSession;
        }

        if(that.onBadGateway){
            options.onBadGateway = that.onBadGateway;
        }

        if(that.onBadGatewayEnd){
            options.onBadGatewayEnd = that.onBadGatewayEnd;
        }

        return options;
    };

    this.fetch = function(options){
        var tmpCollection = this.addCollection({});
        return tmpCollection.fetch(options);
    };

    this.save = function(options){
        var tmpCollection = this.addCollection({});
        return tmpCollection.save(options);
    };

    this.uploadFile = function(fd){
        var tmpCollection = this.addCollection({});
        return tmpCollection.uploadFile(fd);
    };

    this.remove = function(options){
        var tmpCollection = this.addCollection({});
        return tmpCollection.remove(options);
    };

    this.removeGraceIp = function(options){
        var tmpCollection = this.addCollection({});
        return tmpCollection.removeGraceIp(options);
    };

    this.action = function(options){
        var tmpCollection = this.addCollection({});
        return tmpCollection.action(options);
    };

    var Collection = function(){
        this.id = null;
        this.path = null;
        this.validation = null;
        this.items = [];

        this.type = null;
        this.deferObj = {};
        this.defer = null;

        this.remove = function(options) {
            return (function(){
                var url;
                if (options.path) {
                    options.path = (that.urlPrefix ? that.urlPrefix : '') + options.path;
                    url = options.path;
                    if (options.type) {
                        url = url  + "?type=" + options.type;
                    }
                } else {
                    url = (that.urlPrefix ? that.urlPrefix : '') + "/remove?type=" + options.type;
                }

                if(options.accountId){
                    url += "&accountId="+options.accountId;
                }

                xhrSend({
                    method: 'POST',
                    authenticityToken: that.authenticityToken,
                    url : url,
                    data: options.items,
                    dataObj: 'json',
                    success: options.success,
                    error: options.error
                });
            }).call(this);
        };

        this.removeGraceIp = function(options) {
            return (function(){
                var url;
                if (options.path) {
                    options.path = (that.urlPrefix ? that.urlPrefix : '') + options.path;
                    url = options.path;
                } else {
                    url = (that.urlPrefix ? that.urlPrefix : '') + "/removeGraceIp?";
                }

                if(options.accountId){
                    url += "accountId="+options.accountId;
                }

                xhrSend({
                    method: 'POST',
                    authenticityToken: that.authenticityToken,
                    url : url,
                    data: options.items,
                    dataObj: 'json',
                    success: options.success,
                    error: options.error
                });
            }).call(this);
        };

        this.uploadFile= function(options){
            return (function(){
                xhrSend(options);
            }).call(this);
        };

        this.action = function(options){
            return (function(){

                options.method = options.method || "POST";

                options = that.processOptions.call(this, options);

                xhrSend(options);

            }).call(this);
        };

        this.save = function(options){
            return (function(){

                options.method = options.method || "POST";

                options = that.processOptions.call(this, options);

                xhrSend(options);

            }).call(this);
        };

        this.fetch = function(options, deferByOptions){
            return (function(){
                if(!options) options = {};
                options.method = options.method || "GET";

                options = that.processOptions.call(this, options);

                if(this.defer || options.defer){
                    var deferId = 1;
                    if(deferByOptions){
                        deferId = options.queryParams;
                    }
                    if(this.deferObj[deferId]){
                        global.clearTimeout(this.deferObj[deferId]);
                        this.deferObj[deferId] = null;
                    }

                    this.deferObj[deferId] = global.setTimeout(function(){
                        return xhrSend(options);
                    }, this.defer || options.defer);

                    return this.deferObj[deferId];
                }


                return xhrSend(options);
            }).call(this);
        };
    };

    var XHR = global.XMLHttpRequest || ActiveXObject;

    function xhrSend(options){
        options = options || {};

        if(options.loader){
            options.loader.apply(this, ["show", options.id]);
        }
        var request = new XHR('MSXML2.XMLHTTP.3.0');

        if(options.mimeType){
            request.overrideMimeType = options.mimeType;
        }

        var data;

        if(options.data){
            if(options.skipParsePostData){
                data = options.data;
            }
            else{
                data = JSON.stringify(options.data);
            }

            if(options.dataObj){
                data = options.dataObj + '=' + encodeURIComponent(data);
            }
        }

        if (options.authenticityToken && options.method && options.method.toLocaleLowerCase() !== 'get') {
            data = ((data + '&') || '') + 'authenticityToken=' + encodeURIComponent(options.authenticityToken);
        }

        var thisRequest = that.requests.filter(function(req) { return req.url === options.url && req.data === data})[0];
        if (thisRequest) {
            // if we're already sending the exact same request don't send it again, but keep the details on what to do
            // when returning and run them when the request returns
            if (!thisRequest.duplicateRequests) thisRequest.duplicateRequests = [];
            thisRequest.duplicateRequests.push(options);
            return thisRequest;
        }

        request.open(options.method, options.url, true);

        if(!options.file)
            request.setRequestHeader('Content-type', options.contentType || 'application/x-www-form-urlencoded');

        if (options.headers) {
            for (var headerName in options.headers) {
                if (options.headers.hasOwnProperty(headerName)) {
                    request.setRequestHeader(headerName, options.headers[headerName]);
                }
            }
        }

        that.requests.push({url: options.url, data: data});

        request.onreadystatechange = function () {
            if (request.readyState === 4) {
                handleResponse(request, options, data);
                var thisRequest = that.requests.filter(function (req) {
                    return req.url === options.url && req.data === data
                })[0];
                if (thisRequest) {
                    if (thisRequest.duplicateRequests) {
                        thisRequest.duplicateRequests.forEach(function (otherOptions) {
                            handleResponse(request, otherOptions, data);
                        });
                    }
                    that.requests.splice(that.requests.indexOf(thisRequest), 1);
                }
            }
        };


        if(options.file){
            options.file.append('authenticityToken', store.authenticityToken);
            if(options.onProgress)
                request.upload.onprogress = options.onProgress;
            request.send(options.file);
        }
        else{
            request.send(data || null);
        }

        return request;
    }

    function handleResponse(request, options, data) {
        if(options.loader){
            options.loader.apply(this, ["hide", options.id]);
        }

        if(request.status === 502){
            if (options.onBadGateway && typeof options.onBadGateway === "function") {
                options.onBadGateway(options.rt);
            }
        }
        else {
            if (options.onBadGatewayEnd && typeof options.onBadGatewayEnd === "function") {
                options.onBadGatewayEnd();
            }
        }

        if (request.status === 419 || request.status === 511) {
            if (options.onExpireSession && typeof options.onExpireSession === "function") {
                options.onExpireSession();
            }

            if (request.status === 419) {
                window.location = "/login";
            } else if (request.status === 511) {
                that.requests = [];
                window.location = "/session-expired";
            }

            return;
        }

        var res;
        if (request.responseText !== "" || request.response !== ""){
            if ((window.location.origin + "/login") == request.responseURL){
                if (options.onExpireSession && typeof options.onExpireSession === "function") {
                    options.onExpireSession();
                }
                window.location = "/login";
            } else {
                try {
                    if(options.rawResponse) {
                        res = request.responseText || request.response;
                    } else {
                        res = JSON.parse(request.responseText || request.response);
                    }
                } catch(e){
                    res = request.responseText || request.response;
                }
            }
        }
        else {
            res = "";
        }

        if (request.status === 200) {
            if(options.success && typeof options.success === 'function'){
                options.success.apply(options.collection, [res, that.utils.parseResponseHeaders(request.getAllResponseHeaders())]);

            }
        }
        else if(options.error && typeof options.error === 'function'){
            options.error.apply(options.collection, [res, that.utils.parseResponseHeaders(request.getAllResponseHeaders())]);
        }


        if(options.nextFunc){
            options.nextFunc();
        }

    }

    var Utils = function(){
        this.convertObjectToQueryString = function(inputObject) {
            var str = '';

            for(var key in inputObject) {
                if (!inputObject.hasOwnProperty(key) || typeof inputObject[key] === 'function') { continue; }
                if (typeof inputObject[key] === 'object') {
                    str += that.utils.convertObjectToQueryString(inputObject[key]);
                } else {
                    str += key + '=' + encodeURIComponent(inputObject[key]) + '&';
                }
            }

            return str;
        };

        // The headers are 1 string of all headers. New-line separates between headers. Header format is: "Key: Value"
        this.parseResponseHeaders = function parseResponseHeaders(headerStr) {
            var headers = {};
            if (!headerStr) {
                return headers;
            }
            // split string to headers
            var headerPairs = headerStr.split('\u000d\u000a');
            for (var i = 0; i < headerPairs.length; i++) {
                var headerPair = headerPairs[i];
                // split header to key and value:
                // Can't use split() here because it does the wrong thing
                // if the header value has the string ": " in it.
                var index = headerPair.indexOf('\u003a\u0020');
                if (index > 0) {
                    var key = headerPair.substring(0, index);
                    headers[key] = headerPair.substring(index + 2);
                }
            }
            return headers;
        }
    };

    this.utils = new Utils();
};

Store.prototype.clearRequests = function() {
    this.requests = [];
};

var store;

(function() {
    store = new Store({});
    if(typeof authenticityToken !== "undefined"){
        store.authenticityToken = authenticityToken;
    }
    if(typeof storePrefix !== "undefined"){
        store.urlPrefix = storePrefix;
    }
})();
